  <template>
  <form class="ep-user" action="">
    <h2 class="ep-user__title">{{$t('form.signature.user-signature')}}</h2>
    <div class="personal-data__btn-block ep-user__block-add">
      <button class="gui-btn gui-btn--red gui-btn--ep" type="button" @click="addSignature">{{$t('form.signature.add-signature')}}</button>
    </div>
    <div class="ep-user__count">
      <div class="ep-user__container" v-for="(signature, idx) in user.signatures">
        <div class="a-container-form ">
          <div class="a-label ">{{$t('form.signature.name')}}:</div>
          <p class="a-input a-input--disabled ">ЭЦП-{{idx + 1}}</p>
          <span type="button" class="gui-btn-none-style" @click="onSignatureCheckClick(signature.id)">
            <img class="accreditation__reg-img" src="@/assets/img/static/b-icon_edit.svg" alt="">
          </span>
        </div>
        <div class="a-container-form ">
          <div class="a-label ">{{$t('form.signature.status')}}:</div>
          <p class="a-input a-input--disabled " v-t="signature.state.label"></p>
        </div>
        <div class="a-container-form ">
          <div class="a-label ">{{$t('form.accreditation.due-date')}}:</div>
          <date-time class="a-input a-input--disabled" :value="signature.expirationDate" :time="false"></date-time>
        </div>
        <div class="personal-data__btn-block ">
          <button class="gui-btn gui-btn--white-border gui-btn--w-140" type="button" @click="removeSignature({signId: signature.id})">{{$t('buttons.delete-signature')}}</button>
        </div>
      </div>
    </div>

    <signing-dialog ref="signing"
                    @signed="sendSignature">
    </signing-dialog>
    <signature-details-dialog ref="signCheck"></signature-details-dialog>
  </form>
</template>

<script>
  import SigningDialog from '@/components/common/dialogs/SigningDialog'
  import SignatureDetailsDialog from '@/components/common/dialogs/SignatureDetailsDialog'

  export default {
    components: {
      SigningDialog,
      SignatureDetailsDialog
    },

    computed: {
      permissions() {
        return this.$store.getters.currentUser.permissions
      },

      user() {
        return this.$store.getters.currentUser
      }
    },

    methods: {
      addSignature() {
        this.$refs.signing.open({
          text: 'Заявка участника администратору для регистрации электронной подписи'
        });
      },

      async sendSignature(result) {
        this.runBlockerAction(async () => {
          try {
            this.$refs.signing.close();

            await this.$store.dispatch('attachSignature', {
              text: result.data,
              signature: result.signature
            })
          }
          catch(e) {
            console.error('unable to attach signature', e);
            this.globalErrorHandler(e);
          }
        })
      },

      async removeSignature({ signId }) {
        this.runBlockerAction(async () => {
          try {
            await this.$store.dispatch('removeSignature', { signId })
          }
          catch(e) {
            console.error('unable to remove signature', e);
            this.globalErrorHandler(e);
          }
        })
      },

      async onSignatureCheckClick(signId) {
        this.runAction(async () => {
          try {
            const signature = await this.$store.dispatch('checkSignature', {
              userId: this.user.id,
              signId
            });

            this.$refs.signCheck.open(signature);
          }
          catch(e) {
            console.error('unable to check signature', e);
            this.globalErrorHandler(e);
          }
        })
      }
    }
  }
</script>

<style scoped>

</style>
